<!-- 云稼商城 -->
<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner"/>
      </el-carousel-item>
    </el-carousel>
    <div class="store_top_bg">
      <div class="store_top_title">云稼电商解决方案</div>
      <div class="store_top_content">
        商城系统全渠道多终端覆盖，完善技术架构支撑企业级服务
      </div>
      <div class="store_bottom">
        <img
          class="store_bottom_img"
          src="../../../static/other/ic_store_bottom_img.png"
        />
        <div class="store_bottom_text">
          云稼G·S2B2C是一种集合政府部门、供货商赋能于渠道商并共同服务于顾客的全新电子商务营销模式。一方面，在政府部门的指导和监管下，供货商筛选出来供分销商集中采购，另一方面提供技术支持、平台渠道、技能培训给分销商，使其能更好的为顾客服务
        </div>
      </div>
    </div>
    <div class="group_bg">
      <div class="group_center">
        <div class="group_center_left">
          <div class="group_center_left_title">适用群体</div>
          <div class="group_center_left_content">
            互联网时代，消费群体更喜欢线上购物，线下体验，通过云稼电商平台，让田间地头的农产品能够销售全国各地，打破信息不对称，实现优质优价，助力当地农业经济发展，促进农民增收
          </div>
        </div>
        <img
          class="group_center_right_img"
          src="../../../static/other/ic_group_center_right_img.png"
        />
      </div>
    </div>
    <!-- 电商功能 -->
    <div class="store_function_bg">
      <div class="store_function_title">电商功能</div>
      <div class="store_function_content">完善的前后台功能体系</div>
      <div class="store_function_tabes">
        <el-tabs v-model="function_activeId" tab-position="left">
          <el-tab-pane
            v-for="(item, sIndex) in subjectList"
            :key="sIndex"
            :name="sIndex + ''"
          >
            <template slot="label">
              <div class="store_function_tabs_text">
                <div style="width: 80px">{{ item.tabName }}</div>
                <div
                  class="store_function_right_bg"
                  v-if="function_activeId == sIndex"
                >
                  <img
                    class="store_function_right_img"
                    src="../../../static/other/ic_country_serve_right.png"
                  />
                </div>
              </div>
            </template>
            <div class="store_function_bottom">
              <img class="store_function_bottom_img" :src="item.img" />

              <div class="store_function_bottom_right">
                <div class="store_function_bottom_right_title">
                  {{ item.tabName }}
                </div>
                <div class="store_function_bottom_right_content">
                  {{ item.content }}
                </div>
                <div class="store_function_bottom_right_label_parent">
                  <div
                    class="store_function_bottom_right_label"
                    v-for="(label, index) in item.lables"
                    :key="index"
                  >
                    {{ label }}
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 产品特点 -->
    <div class="store_trait_bg">
      <div class="store_trait_title">产品特点</div>
      <div class="store_trait_bottom">
        <div
          :class="
            index % 2 == 0 ? 'store_trait_item' : 'store_trait_item_top32'
          "
          v-for="(item, index) in trait_items"
          :key="index"
        >
          <div class="store_trait_item_bg">
            <img class="store_trait_item_top_img" :src="item.img_top" />
            <img class="store_trait_item_center_img" :src="item.img" />
            <div class="store_trait_item_title">{{ item.title }}</div>
            <div class="store_trait_item_content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      function_activeId: "0",
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),

        },
      ],
      subjectList: [
        {
          tabName: "平台运营",
          img: require("../../../static/other/ic_store_function_img1.png"),
          content: "覆盖PC+APP+小程序多个终端，多种营销方式提高复购率",
          lables: [
            "入驻商家管理",
            "会员管理",
            "门店管理",
            "结算管理",
            "店铺管理",
            "商品信息",
            "供应商管理",
            "区域管理",
            "可视化装修",
            "订单管理",
            "移动终端管理",
            "营销活动",
          ],
        },
        {
          tabName: "入驻商家",
          img: require("../../../static/other/ic_store_function_img2.png"),
          content: "支持商家自主申请入驻平台，门店可视化装修，数据统计一目了然",
          lables: [
            "店铺概况",
            "商品管理",
            "订单管理",
            "可视化装修",
            "营销活动",
            "门店管理",
            "门店设置",
            "账单管理",
            "服务信息",
            "客服管理",
            "店铺可视化",
            "小程序管理",
          ],
        },
        {
          tabName: "门店后台",
          img: require("../../../static/other/ic_store_function_img3.png"),

          content: "支持设定多种订单方式，库存管理一键到位",
          lables: [
            "后台独立",
            "门店职员",
            "门店订单",
            "可视化装修",
            "到店自提",
            "门店库存",
            "门店管理",
            "门店抢单",
            "抢单发货",
            "库存同步",
          ],
        },
        {
          tabName: "平台会员",
          img: require("../../../static/other/ic_store_function_img4.png"),
          content:
            "会员随时充值 体现，想有会员积分功能，会员等级特价、会员分销等权限",
          lables: [
            "充值/提现",
            "会员积分",
            "评价晒单",
            "退款退货",
            "违规举报",
            "会员等级",
            "商品分销",
            "注册赠券",
            "等级特价",
            "收藏/足迹",
            "推荐会员",
            "佣金提现",
          ],
        },
        {
          tabName: "促销活动",
          img: require("../../../static/other/ic_store_function_img5.png"),
          content:
            "多种促销活动功能，增加用户黏性，秒杀、拼团、砍价，促进订单成交",
          lables: [
            "秒杀",
            "红包",
            "优惠券",
            "储值卡",
            "礼品卡",
            "拼团",
            "砍价",
            "团购",
            "满减满赠",
            "超值礼包",
            "积分商城",
            "满折",
          ],
        },
      ],
      trait_items: [
        {
          title: "会员制分销",
          content:
            "用户付费成为高级会员，并享受推挂钩分佣权利，解决平台流量增长难题",
          img_top: require("../../../static/other/ic_store_trait_top_img1.png"),
          img: require("../../../static/other/ic_store_trait_img1.png"),
        },
        {
          title: "多种营销模块",
          content:
            "拼团、砍价、秒杀、积分等多种营销功能帮助商家精准运营，提高下单率",
          img_top: require("../../../static/other/ic_store_trait_top_img2.png"),
          img: require("../../../static/other/ic_store_trait_img2.png"),
        },
        {
          title: "支持零售 批发",
          content:
            "打造适合供应商、批发商的B2B平台，实现订单交易、物流配送一体化管理",
          img_top: require("../../../static/other/ic_store_trait_top_img3.png"),
          img: require("../../../static/other/ic_store_trait_img3.png"),
        },
        {
          title: "自定义活动主题",
          content:
            "支持自定义专题页面，针对特定商品进行装修，轻松拥有一个炫酷的专题页",
          img_top: require("../../../static/other/ic_store_trait_top_img4.png"),
          img: require("../../../static/other/ic_store_trait_img4.png"),
        },
        {
          title: "CRM会员管理",
          content: "加强对会员的管理、营销、互动，维护私域，提升会员的复购率",
          img_top: require("../../../static/other/ic_store_trait_top_img5.png"),
          img: require("../../../static/other/ic_store_trait_img5.png"),
        },
        {
          title: "手机管理后台",
          content:
            "商家可以随时通过手机端掌握订单、店铺经营状况，管理更便捷更高效",
          img_top: require("../../../static/other/ic_store_trait_top_img6.png"),
          img: require("../../../static/other/ic_store_trait_img6.png"),
        },
      ],
    };
  },

  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height:100%; 
}
.store_top_bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f3f5fa;
  height: 650px;
  .store_top_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .store_top_content {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;

    color: #666666;
  }
  .store_bottom {
    display: flex;
    flex-direction: row;
    width: 1180px;
    margin-top: 80px;
    .store_bottom_img {
      width: 694px;
    }
    .store_bottom_text {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #333333;
      margin-left: 80px;
      margin-top: 110px;
    }
  }
}
.group_bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #ffffff;
  height: 650px;
  .group_center {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1180px;
    .group_center_left {
      display: flex;
      flex-direction: column;
      .group_center_left_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
        margin-bottom: 8px;
      }
      .group_center_left_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #666666;
        width: 450px;
      }
    }
    .group_center_right_img {
      margin-left: 98px;
      width: 632px;
      height: 434px;
    }
  }
}

.store_function_bg {
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;

  .store_function_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }

  .store_function_content {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
    margin-bottom: 48px;
  }

  .store_function_tabes {
    width: 1180px;
    margin-bottom: 80px;
    >>> .el-tabs__nav-scroll {
      background-color: #f3f5fa;
    }
    /* 去除最底部下划线 */
    >>> .el-tabs__nav-wrap::after {
      position: static !important;
    }
    /*隐藏tab下面的一横*/
    >>> .el-tabs__active-bar {
      background-color: transparent !important;
    }
    >>> .el-tabs__nav {
      margin: 30px 0;
    }
    >>> .el-tabs__item {
      width: 162px;
      height: 48px;
      line-height: 48px;
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
      padding-left: 24px;
      padding-right: 10px;
    }
    >>> .el-tabs__item:hover {
      color: #333333;
    }
    /*选中样式*/
    >>> .el-tabs__item.is-active {
      width: 162px;
      height: 48px;
      border-radius: 28px;
      font-size: 20px;
      color: #ffffff;
      background-color: #3370ff;
      margin-bottom: 20px;
      padding-left: 24px;
      padding-right: 10px;
    }

    .store_function_tabs_text {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .store_function_right_bg {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        width: 28px;
        height: 28px;
        border-radius: 14px;
        .store_function_right_img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .store_function_bottom {
      display: flex;
      flex-direction: row;
      background: #ffffff;
      border-radius: 4px;
      height: 440px;
      margin-left: 32px;

      .store_function_bottom_img {
        width: 360px;
        height: 210px;
        margin-left: 48px;
        margin-top: 125px;
        margin-right: 80px;
      }

      .store_function_bottom_right {
        display: flex;
        flex-direction: column;
        margin-top: 80px;
        .store_function_bottom_right_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          color: #333333;
          margin-bottom: 12px;
        }
        .store_function_bottom_right_content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #666666;
          margin-right: 48px;
        }
        .store_function_bottom_right_label_parent {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-top: 32px;

          .store_function_bottom_right_label {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8f8f8;
            border-radius: 4px;
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            width: 104px;
            height: 32px;
            margin-right: 12px;
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}

.store_trait_bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  height: 650px;
  .store_trait_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 60px;
  }

  .store_trait_bottom {
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    .store_trait_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      background: linear-gradient(
        180deg,
        #f2f3f8 0%,
        #eff2fb 52.92%,
        #f4f5f7 100%
      );
      border-radius: 16px;
      width: 180px;
      height: 385px;
      margin-right: 20px;
    }

    .store_trait_item_top32 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      background: linear-gradient(
        180deg,
        #f2f3f8 0%,
        #eff2fb 52.92%,
        #f4f5f7 100%
      );
      border-radius: 16px;
      width: 180px;
      height: 385px;
      margin-right: 20px;
      margin-top: 32px;
    }

    .store_trait_item_bg {
      display: flex;
      flex-direction: column;
      width: auto;

      .store_trait_item_top_img {
        width: 156px;
        height: 128px;
        margin-top: 15px;
        margin-bottom: 24px;
      }
      .store_trait_item_center_img {
        width: 52px;
        height: 52px;
        margin-bottom: 16px;
        margin-left: 12px;
      }
      .store_trait_item_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        margin-left: 12px;
      }
      .store_trait_item_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-top: 4px;
        margin-left: 12px;
        width: 144px;
        height: 90px;
        margin-bottom: 30px;
      }
    }
  }
}
</style>